module.exports = __webpack_public_path__ + "img/back-button-circle.d0247229.svg";